export default {"src":"/_next/static/media/data-leak-detection.f633e957.svg","height":274,"width":274,"blurWidth":0,"blurHeight":0};